import React, { useState } from "react";
import Style from "./index.module.scss";
import Header from "components/Header";
import { Breadcrumb, Button, Card, Tooltip, Table, message, Modal } from "antd";
import { useHistory, useParams } from "react-router-dom";
import { BiUndo } from "react-icons/bi";
import Tools from "./components/Tools";
import { ColumnProps } from "antd/lib/table";
import Copy from "copy-to-clipboard";
import {
    CourseInvitationListItem,
    createInvitationCode,
    getCourseInvitation,
    getStuCourseInvitationList,
    removeStuCourse,
    stopStuCourseInvitation
} from "service/inivitationCode";
import useRequest from "utils/useRequest";
import moment from "moment";
import ResultMessage from "components/CourseComponents/ResultMessage";
import { errorMessage } from "service/service";
import useRequestFn from "utils/useRequestFn";

export default function PageInvitatinCode() {
    const history = useHistory();
    const [search, setSearch] = useState("");
    const { courseNo, courseSeq, courseName, teacherName } =
        useParams<StringMap>();
    const [data, { loading }, refreshData] = useRequest(
        () => getStuCourseInvitationList(courseNo, courseSeq, search),
        {},
        [courseNo, courseSeq, search]
    );
    const [code, {}, refreshCode] = useRequest(
        () => getCourseInvitation(courseNo, courseSeq),
        {},
        [courseNo, courseSeq]
    );
    const [createInvitation, { loading: createLoading }] =
        useRequestFn(createInvitationCode);
    const [stopInvitation, { loading: stopLoading }] = useRequestFn(
        stopStuCourseInvitation
    );

    const title = (
        <div className={Style.head}>
            <div>
                <Tooltip title={courseName} placement="bottomLeft">
                    <span className={Style.courseTitle}>{courseName}</span>
                </Tooltip>
                <Button
                    size="small"
                    className={Style.goBack}
                    onClick={() => history.goBack()}>
                    <BiUndo size={16} />
                    返回
                </Button>
            </div>
        </div>
    );

    function handleCopy() {
        Copy(
            `${teacherName}老师邀请你来上课啦~` +
                "\n" +
                `课程名称：${courseName}` +
                "\n" +
                `课程邀请码：${code}` +
                "\n" +
                `请您打开电脑或手机的浏览器复制白果云学生端登录地址，登录后输入课程邀请码即可加入课堂` +
                "\n" +
                `白果云学生端登录地址：https://ginkgostu.dufe.edu.cn`
        );
        message.success("复制成功");
    }

    async function handleOpen() {
        try {
            await createInvitation(courseNo, courseSeq);
            message.success("启用邀请码操作成功");
            refreshCode();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    async function handleClose() {
        try {
            await stopInvitation(code);
            message.success("停用邀请码操作成功");
            refreshCode();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    function handleDelete(studentNo: string, name: string) {
        Modal.confirm({
            title: `确定要移除“${name}”吗？`,
            content:
                "移除学生后，该学生在这个班中的所有互动数据都将被删除且不可恢复，确定要移除吗？",
            onOk: async () => {
                try {
                    await removeStuCourse(courseNo, courseSeq, studentNo);
                    message.success("移除学生操作成功");
                    refreshData();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    }

    const columns: ColumnProps<CourseInvitationListItem>[] = [
        {
            title: "序号",
            dataIndex: "index",
            align: "center",
            render: (text, record, index) => {
                return <div>{index + 1}</div>;
            }
        },
        {
            title: "学号",
            dataIndex: "studentNo",
            align: "center"
        },
        {
            title: "姓名",
            dataIndex: "name",
            align: "center"
        },
        {
            title: "性别",
            dataIndex: "sex",
            align: "center"
        },
        {
            title: "院系",
            dataIndex: "department",
            align: "center"
        },
        {
            title: "专业",
            dataIndex: "subject",
            align: "center"
        },
        {
            title: "班级",
            dataIndex: "className",
            align: "center"
        },
        {
            title: "加入时间",
            dataIndex: "createTime",
            align: "center",
            render: text => <div>{moment(text).format("MM-DD HH:mm:ss")}</div>
        },
        {
            title: "操作",
            align: "center",
            render: (text, record) => {
                return (
                    <Button
                        type="link"
                        onClick={() =>
                            handleDelete(record.studentNo, record.name)
                        }>
                        移除学生
                    </Button>
                );
            }
        }
    ];

    return (
        <div>
            <Header />

            <div className={Style.root}>
                <Breadcrumb separator=">">
                    <Breadcrumb.Item href="/">首页</Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <a href="">我的邀请</a>
                    </Breadcrumb.Item>
                </Breadcrumb>

                <Card
                    title={title}
                    bordered={false}
                    className={Style.container}>
                    <div className={Style.head}>
                        <div className={Style.subTitle}>
                            <span>编号 {courseNo}</span>
                            <span>序号 {courseSeq}</span>
                        </div>
                        {!code && (
                            <div className={Style.rightBtn}>
                                <div className={Style.tip}>尚未启用邀请码</div>
                                <Button
                                    type="primary"
                                    ghost
                                    className={Style.button}
                                    onClick={handleOpen}
                                    loading={createLoading}>
                                    启用邀请码
                                </Button>
                            </div>
                        )}
                        {code && (
                            <div className={Style.rightBtn}>
                                <div className={Style.code}>
                                    <div className={Style.codeInfo}>{code}</div>
                                    <div
                                        className={Style.copyBtn}
                                        onClick={handleCopy}>
                                        点击复制
                                    </div>
                                </div>
                                <Button
                                    type="primary"
                                    ghost
                                    className={Style.button}
                                    onClick={handleClose}
                                    loading={stopLoading}>
                                    停用邀请码
                                </Button>
                            </div>
                        )}
                    </div>

                    <div className={Style.content}>
                        <Tools onSearch={setSearch} length={data?.length} />
                        <Table
                            columns={columns}
                            rowKey="studentNo"
                            dataSource={data || []}
                            pagination={false}
                            loading={loading}
                        />
                    </div>
                </Card>
            </div>
        </div>
    );
}
